import Input from "../components/Input/Input";
import Select from "../components/Select/Select";
import Textarea from "../components/Textarea/Textarea";

/**
 * Global reusable function to render form fields
 * @param {object} field - field config object
 * @param {number} idx - index of the field
 * @param {function} changeHandler - function to handle onChange
 * @param {function} onFocusHandler - function to handle onFocus
 * @param {object} errors - validation errors object
 */
export const renderField = (field, idx, handleImageChange, changeHandler, onFocusHandler, errors = {}) => {
  if (field.showIf === false) return null;

  const colClass = `col-md-${field.col || 12}`;
  const commonProps = {
    label: field.label,
    name: field.name,
    value: field.value || "",
    onChangeHandler: changeHandler,
    onFocusHandler: onFocusHandler,
    error: errors[field.name],
    placeholder: field.placeholder || `Enter ${field.label}`,
    required: field.required,
    disabled: field.disabled,
    maxLength: field.maxLength,
    minLength: field.minLength,
    pattern: field.pattern,
  };

  // File input
  if (field.isFile) {
    return (
      <div className={colClass} key={idx}>
        <Input
          {...commonProps}
          type="file"
          onChangeHandler={(e) => handleImageChange(e)}

        />
      </div>
    );
  }
  // Switch by type
  switch (field.type) {
    case "text":
    case "number":
    case "email":
    case "date":
      return (
        <div className={colClass} key={idx}>
          <Input {...commonProps} type={field.type} />
        </div>
      );
    case "select":
      return (
        <div className={colClass} key={idx}>
          <Select
            {...commonProps}
            name={field.name}
            value={field.value || ""}
            options={field.options || []}
            placeholder={field.placeholder || `Select ${field.label}`}
          />
        </div>
      );
    case "textarea":
      return (
        <div className={colClass} key={idx}>
          <Textarea
            {...commonProps}
            onChange={changeHandler}
            rows={field.rows || 3}
          />
        </div>
      );

    default:
      return null;
  }
};
